import { defineStore } from 'pinia'

export const useToastStore = defineStore('toast', {
  state: () => ({
    show: false,
    message: '',
    color: 'success',
    timeout: 3000
  }),
  actions: {
    trigger(message, color = 'success', timeout = 3000) {
      this.message = message
      this.color = color
      this.timeout = timeout
      this.show = true
    },
    success(message) {
      this.trigger(message, 'success')
    },
    error(message) {
      this.trigger(message, 'error')
    },
    info(message) {
      this.trigger(message, 'info')
    },
    warning(message) {
      this.trigger(message, 'warning')
    }
  }
})
